/**
 * H12 — Renders the right-justified slot status text (vote + conflict).
 * Replaces the buggy adjacent-string concatenation at SchedulerPage.jsx that
 * previously produced "BusyFeasible" / "BusyNo vote" strings.
 *
 * Inputs:
 *   - vote: "FEASIBLE" | "PREFERRED" | null
 *   - hasConflict: boolean (from blocker presence)
 *   - noTimesWork: boolean
 *   - isUrgentOverride: boolean (red-alert state — autoVoteEnabled &&
 *       autoSource === "auto-conflict-override" && reason.kind === "conflict"
 *       && hasUnacknowledgedRefIds(reason))
 *
 * Output rules (H12 5-state matrix):
 *   noTimesWork         → "Unavailable" (slate)
 *   isUrgentOverride    → "Conflict" red (with stacked vote line if present)
 *   hasConflict         → stacked vote / "Conflict" in amber
 *   else                → "No vote" / "Feasible" / "Preferred" in slate
 */
export function SlotStatusText({ vote, hasConflict, noTimesWork, isUrgentOverride }) {
  if (noTimesWork) {
    return <span className="text-xs text-slate-400 dark:text-slate-500">Unavailable</span>;
  }
  if (isUrgentOverride) {
    return (
      <div className="flex flex-col items-end text-xs font-medium text-red-500 dark:text-red-400">
        {vote === "PREFERRED" && <span>Preferred</span>}
        {vote === "FEASIBLE" && <span>Feasible</span>}
        <span>Conflict</span>
      </div>
    );
  }
  if (hasConflict) {
    return (
      <div className="flex flex-col items-end text-xs font-medium text-amber-600 dark:text-amber-400">
        {vote === "PREFERRED" && <span>Preferred</span>}
        {vote === "FEASIBLE" && <span>Feasible</span>}
        <span>Conflict</span>
      </div>
    );
  }
  if (vote === "PREFERRED") return <span className="text-xs text-slate-400 dark:text-slate-500">Preferred</span>;
  if (vote === "FEASIBLE") return <span className="text-xs text-slate-400 dark:text-slate-500">Feasible</span>;
  return <span className="text-xs text-slate-400 dark:text-slate-500">No vote</span>;
}
